import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, } from "../../components/ui/Card";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Eye, EyeOff } from "lucide-react";
import Logo from "../../assets/images/IRStructureLogo.png";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../../store/actions/auth/resetPasswordAction";
import { useDispatch } from "react-redux";

const ResetPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [error, setError] = useState({
        newPassword: '',
        confirmPassword: '',
    });
    const [userInfo, setUserInfo] = useState({
        newPassword: '',
        confirmPassword: '',
    });

    const handleChange = (e) => {
        setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    const handleSubmit = () => {
        if (!userInfo?.newPassword && !userInfo?.confirmPassword) {
            setError({
                newPassword: 'Password is required.',
                confirmPassword: 'Confirm password is required.',
            });
        } else if (!userInfo?.newPassword) {
            setError({
                newPassword: 'Password is required.',
                confirmPassword: '',
            });
        } else if (!userInfo?.confirmPassword) {
            setError({
                newPassword: '',
                confirmPassword: 'Confirm password is required.',
            });
        } else if (userInfo?.newPassword !== userInfo?.confirmPassword) {
            setError({
                newPassword: '',
                confirmPassword: 'Passwords do not match.',
            });
        } else {
            setError({ newPassword: '', confirmPassword: '' });
            if (token) {
                dispatch(resetPassword(userInfo?.confirmPassword, token, navigate));
            }
        }
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };

    return (
        <div className="flex justify-center items-center h-screen p-4">
            <Card className="max-w-2xl w-full relative">
                <div className='flex justify-center items-center'>
                    <img className='absolute -top-16 left-[30%] w-56' src={Logo} alt="" />
                </div>
                <CardHeader>
                    <CardTitle className="text-xl font-500">Reset Password</CardTitle>
                    <CardDescription>
                        Enter your new password to reset your account.
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <div className="space-y-1 relative">
                        <Label htmlFor="newPassword" className="mb-2">New Password</Label>
                        <Input
                            id="newPassword"
                            type={passwordVisible ? 'text' : 'password'}
                            name="newPassword"
                            placeholder="********"
                            onChange={handleChange}
                            onKeyDown={handleKeyPress}
                            autoComplete="off"
                            value={userInfo.newPassword}
                        />
                        <Button
                            className="w-12 bg-transparent order-last py-2 px-0 hover:!bg-transparent border-s absolute right-0 top-[1.6rem] rounded-ss-none rounded-es-none"
                            onClick={togglePasswordVisibility}
                        >
                            {passwordVisible ? <EyeOff className="text-black" /> : <Eye className="text-black" />}
                        </Button>
                        {error.newPassword && (
                            <div className="text-red-500 text-xs">{error.newPassword}</div>
                        )}
                    </div>
                    <div className="space-y-1 relative">
                        <Label htmlFor="confirmPassword" className="mb-2">Confirm Password</Label>
                        <Input
                            id="confirmPassword"
                            type={confirmPasswordVisible ? 'text' : 'password'}
                            name="confirmPassword"
                            placeholder="********"
                            onChange={handleChange}
                            onKeyDown={handleKeyPress}
                            autoComplete="off"
                            value={userInfo.confirmPassword}
                        />
                        <Button
                            className="w-12 bg-transparent order-last py-2 px-0 hover:!bg-transparent border-s absolute right-0 top-[1.6rem] rounded-ss-none rounded-es-none"
                            onClick={toggleConfirmPasswordVisibility}
                        >
                            {confirmPasswordVisible ? <EyeOff className="text-black" /> : <Eye className="text-black" />}
                        </Button>
                        {error.confirmPassword && (
                            <div className="text-red-500 text-xs">{error.confirmPassword}</div>
                        )}
                    </div>
                    <div className="text-xs text-muted-foreground space-y-1">
                        <p>Password requirements:</p>
                        <ul className="list-disc list-inside space-y-1 ml-2">
                            <li>At least 8 characters long.</li>
                            <li>Contains uppercase and lowercase letters.</li>
                            <li>Contains at least one number.</li>
                        </ul>
                    </div>
                </CardContent>
                <CardFooter className="sm:flex flex-col items-center justify-between block space-y-2">
                    <Button className="w-full" onClick={handleSubmit}>
                        Reset Password
                    </Button>
                    <Button className="w-full" variant="outline" onClick={() => navigate('/login')}>
                        Back to Login
                    </Button>
                </CardFooter>
            </Card>
        </div>
    );
};

export default ResetPassword;
